import axios from 'axios';

export const claimService = {
    getClaimsService: (data) => axios.get('/claim', { auth: true, params: { ...data } }),

    getPendingClaimsTotalService: (data) => axios.get('/claim/total-summary', { auth: true, params: { ...data } }),

    getBillableClaimsTotalService: (data) => axios.get('/appt/total-summary', { auth: true, params: { ...data } }),

    getClaimAgingService: (data) => axios.get('/claim/claim-aging', { auth: true, params: { ...data } }),

    getCompletedClaimTotalsService: (data) => axios.get('/claim/totals', { auth: true, params: { ...data } }),

    getSubmittedClaimsService: (data) => axios.get('/claim/submitted', { auth: true, params: { ...data } }),

    getClaimBatchesService: (data) => axios.get('/claim/batch', { auth: true, params: { ...data } }),

    getClaimBatchByIdService: (id) => axios.get(`/claim/batch/${id}`, { auth: true }),

    getClaimByIdService: (id) => axios.get(`/claim/${id}`, { auth: true }),

    generateClaimService: (body, params) =>
        axios.post(`/claim/generate`, body, {
            auth: true,
            params: params,
            // params: { merge: merge },
        }),

    editClaimService: (id, body) => axios.patch(`/claim/${id}/update`, body, { auth: true }),

    deleteClaimService: (data) => axios.delete(`/claim`, { auth: true, data }),

    changeClaimStatusService: (body) => axios.patch(`/claim/status`, body, { auth: true }),

    /**Claim Status Actions */
    cancelClaimService: (params) => axios.patch(`/claim/cancel-submit`, params, { auth: true }),

    closeClaimService: (id, details) => axios.post(`/claim/${id}/close?details=${details}`, {}, { auth: true }),

    checkClaimStatusService: (params) => axios.post(`/claim/check-status`, params, { auth: true }),

    submitClaimService: (id) => axios.patch(`/claim/submit`, { claimIds: id }, { auth: true }),

    submitClaimClearinghouseService: (id, type) =>
        axios.patch(`/claim/submit-clearinghouse`, { claimIds: id }, { auth: true, params: { clearinghouseType: type } }),

    // submitClaimService: (id, type ) => axios.patch(type === 'officeAlly' ? `/claim/submitOfficeAll` :  `/claim/submit`, { 'claimIds': id }, { auth: true }),

    reSubmitClaimService: (ids) => axios.patch(`/claim/re-submit`, { claimIds: ids }, { auth: true }),

    refreshClaimService: (id) => axios.get(`/claim/${id}/draft`, { responseType: 'arraybuffer', auth: true }),

    resubmitClaimService: (id) => axios.patch(`/claim/${id}/refresh`, null, { auth: true }),

    // removePendingFromClaimService: (id, reason) => axios.delete(`/claim/pending/appt/${id}`, { auth: true, params: { reason: reason }}),

    removePendingFromClaimService: (data) => axios.delete(`/claim/pending/appt`, { auth: true, data }),

    removeFromClaimService: (data) => axios.delete('/claim/appts', { auth: true, data }),
    // removeFromClaimService: (params) => axios.delete(`/claim/appts`, { auth: true }),

    /**Bill Details */
    billClaimPmtService: (id) => axios.get(`/txn/claim/${id}`, { auth: true }),

    billInvoicePmtService: (ids) => axios.get(`/txn/invoice`, { auth: true, params: { billIds: ids } }),

    /** Overview */

    getBillingOverviewService: (params) => axios.get('/claim/claim-overview', { auth: true, params: { ...params } }),

    /** End */

    markAsSecondaryBillingService: (claimId, params) =>
        axios.post(`/claim/${claimId}/pmt/secondary-billing`, {}, { auth: true, params: { ...params } }),

    markAsReadySecondaryBillingService: (claimId, body) => axios.patch(`/claim/${claimId}/secondary-billing`, body, { auth: true }),

    refreshApptUnitsService: (apptId) => axios.patch(`/claim/refresh/appt/${apptId}`, {}, { auth: true }),

    /** Bill Adjustments (CAS) — full replace of the bill's adjustments array */
    updateBillAdjustmentsService: (claimId, billId, adjustments) =>
        axios.put(`/claim/${claimId}/bill/${billId}/adjustments`, { adjustments }, { auth: true }),
};
